export const API_URL = import.meta.env.VITE_API_URL;
export const RECAPTCHA_KEY = import.meta.env.VITE_RECAPTCHA_KEY;
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
export const BUILD_ENV = import.meta.env.VITE_BUILD_ENV;
export const HTTP_CLIENT_XDEBUG_QUERY_PARAMETER = import.meta.env.VITE_HTTP_CLIENT_XDEBUG_QUERY_PARAMETER
